export default __webpack_public_path__ + "justhatched-devices_tablet@2x.79823c69.png";